module.exports = __webpack_public_path__ + "img/3.087d2cb1.svg";